const Urls = {
	Api: {
		product: '/my/api/2/shopping-cart/active/product',
		cart: '/my/cart'
	},
	Templates: {
		product_with_accessory_modal: '/my/api/2/templates?name=modules/accessories/product-with-accessory-modal.html'
	}
};

export default Urls;